import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n/config'; // Initialize i18n
import { initConsoleFilter } from './utils/consoleFilter'; // Filter expected console errors

// Initialize console filter to suppress expected warnings/errors
initConsoleFilter();

createRoot(document.getElementById('root')!).render(
  <App />
);
